<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar title="Cantar"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card mar-to-15">
          <div class="card-content">
            <div class="text-right">
              <p>
                <button class="btn add mar-rt-10"  @click.prevent="goToAdd" :title="$t('general.add')">
                  <img src="/static/img/icons/add.png">
                  {{$t('general.add')}}
                </button>
              </p>
            </div>
            <data-tables
              v-loading="loading"
              :data="tableData"
              :search-def="{}"
              :pagination-def="{}"
              :table-props="{'border': false}"
              style="width: 100%">

              <!-- Define your table columns -->
              <el-table-column
                min-width="10"
                prop="name"
                label="ID">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.id || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="30"
                prop="name"
                label="Name">
                <template slot-scope="props">
                    <div class="cell-center">{{ props.row.name ? props.row.name : "-" }}</div>
                </template>
              </el-table-column>

              <el-table-column
                :width="320"
                :label="$t('general.actions')">
                <template slot-scope="props">
                  <a
                    class="btn delete mar-rt-10"
                    :title="$t('marketingCampaigns.send')"
                    @click="handleDelete(props.row.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                  <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import 'sweetalert2/dist/sweetalert2.css'

export default {
  components: {
    // GeneralTopBar
  },
  created () {
    this.getData()

    this.$bus.$on('refresh', this.handleRefresh)
  },
  data () {
    return {
      loading: true,
      tableData: []
    }
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    handleRefresh () {
      this.getData()
    },
    goToRecord (row, event, column) {
      // this.$router.push('/screens/kds/edit/' + row.id)

      if (typeof this.callback === 'function') {
        this.callback(row.id)
      } else {
        this.globalGoToRecord(row, event, column, '/cantar/edit/')
      }
    },
    goToAdd () {
      this.$router.push('/cantar/add')
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getData () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/cantar', 'GET', data, response => {
        if (response.status === true) {
          this.tableData = response.data.cantar
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    handleDelete (item) {
      var btnCounter = 3
      swal({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      })
      .then((result) => {
        if (result) {
          const data = {
            id: item,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/cantar/' + item, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal(
                '',
                this.$t('general.success'),
                'success'
              )
              this.getData()
            } else {
              swal(
                '',
                response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
          // }
        }
      })
      .catch((err) => {
        if (err) {
        }
      })
      swal.disableConfirmButton()
      const yes = this.$t('general.yes')
      const btnInterval = setInterval(() => {
        btnCounter--
        if (btnCounter >= 1) {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = `${yes} (${btnCounter})`
          }
        } else {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = yes
          }
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    }
  }
}
</script>

<style>
  td.error-spelling-fix-position textarea.label-notification-textarea {
    resize: vertical !important;
    overflow: hidden !important;
    min-height: auto !important;
  }

  .delivery_method{
    display: flex;
    flex-direction: column;
  }
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 10px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }

  .loyaltyPointsModal__footer {
    text-align: end;
  }

  .loyaltyModal {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/CantarList.vue